import React from "react";
import "../../assets/css/Home.css";

const AvailabilityHeader = (props) => {
  return (
    <div>
      <div className="content-header" style={{ height: "90px" }}>
        <div className="content-head">
          <div className="top">
            <div className="flex">
              <h2 className="input-label">Set your availability</h2>
            </div>
          </div>
        </div>
      </div>
      <props.display
        currentUser={props.currentUser}
        data={props.data}
        decodedToken={props.currentUser}
        refetch={props.refetch}
      />
    </div>
  );
};

export default AvailabilityHeader;
